import reservation from "./reservation.component";
import reservationUrls from "./reservation.urls";
import ReservationTransforms from "./reservation.transforms";

const reservationModule = angular
  .module("app.components.reservation", [])
  .component("reservationPage", reservation)
  .service("ReservationTransforms", ReservationTransforms)
  .config(reservationUrls);

export default reservationModule;



// WEBPACK FOOTER //
// ./src/pages/reservation/reservation.module.js